<dr-customer-offers-ui-global-alert></dr-customer-offers-ui-global-alert>
<enelx-navbar [productName]="'Flex'" [url]="navUrl" position="left" [maxMenuElements]="0">
  <div slot="content">
    <div class="header">
      <div class="header__container">
        <h1>{{ 'APP.TITLE' | translate }}</h1>
      </div>
    </div>
    <div class="com-container">
      <dr-customer-offers-ui-filters></dr-customer-offers-ui-filters>
      <div *ngIf="(selectedRegFormControl$ | async)?.id; else errorMessage">
        <div class="com-container_header">
          <div class="com-container_header--tabs">
            <dr-customer-offers-ui-tabs (tabChange)="tabChanged($event)"></dr-customer-offers-ui-tabs>
          </div>
        </div>
        <div class="main-content">
          <router-outlet></router-outlet>
        </div>
      </div>
      <ng-template #errorMessage>
        <dr-customer-offers-ui-no-data [title]="errorMessageTitle" [message]="message"></dr-customer-offers-ui-no-data>
      </ng-template>
    </div>
    <ngx-global-contact-footer></ngx-global-contact-footer>
  </div>
</enelx-navbar><dr-customer-offers-ui-toast></dr-customer-offers-ui-toast>